/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
var isType = require('./is-type');

var isArguments = function isArguments(value) {
  return isType(value, 'Arguments');
};

module.exports = isArguments;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/type/is-arguments.js
// module id = 240
// module chunks = 0